import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/createaccountform.css";
import logo02 from "../images/New folder (4)/logo/LOGO PNG FORMAT WITH TAGLINE (1).png";
import axios from "axios";
import {
  validateName,
  validatePassword,
  validatePhoneNumber,
} from "../validation";
import { BASE_URL } from "../constants/constant";

const CreateAccountForm = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    passwordconformed: "",
    alternativePhone: "",
    phonenumber: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword((prev) => !prev);

  const navigate = useNavigate();

  const formdata = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const validateFields = () => {
    let formErrors = {};
    let isValid = true;

    const {
      firstname,
      lastname,
      email,
      password,
      passwordconformed,
      phonenumber,
      alternativePhone,
    } = formData;

    if (
      !firstname ||
      !lastname ||
      !email ||
      !password ||
      !passwordconformed ||
      !phonenumber
    ) {
      isValid = false;
      formErrors.general = "Please fill in all required fields.";
    }

    if (!validateName(firstname) || !validateName(lastname)) {
      isValid = false;
      formErrors.firstname = "Name should only contain letters.";
      formErrors.lastname = "Name should only contain letters.";
    }

    if (!validatePassword(password)) {
      isValid = false;
      formErrors.password =
        "Password must be 8+ chars with a special character.";
    }

    if (password !== passwordconformed) {
      isValid = false;
      formErrors.passwordconformed = "Passwords do not match.";
    }

    if (
      !validatePhoneNumber(phonenumber) ||
      (alternativePhone && !validatePhoneNumber(alternativePhone))
    ) {
      isValid = false;
      formErrors.phonenumber = "Phone number must be 10 digits.";
      formErrors.alternativePhone = "Phone number must be 10 digits.";
    }

    setErrors(formErrors);

    if (!isValid) {
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }

    return isValid;
  };

  const register = (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    const {
      firstname,
      lastname,
      email,
      password,
      phonenumber,
      alternativePhone,
    } = formData;

    const datas = {
      firstname,
      lastname,
      email,
      password,
      phonenumber,
      alternativePhone,
    };

    axios
      .post(`${BASE_URL}create_user.php`, datas, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (
          response.data.error &&
          response.data.error.includes("Email ID already exists")
        ) {
          alert("Email already exists. Please use a different email address.");
          window.location.reload();
        } else {
          sessionStorage.setItem("user_id", response.data.user_id);
          setShowSuccessModal(true);
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to create account. Please try again.");
        window.location.reload();
      });
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    navigate("/createaccount_submit");
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="container p-4 rounded shadow-lg col-md-4 col-lg-4 createaccount-formdiv">
          <div className="text-center mb-3">
            <img
              src={logo02}
              alt="Logo"
              className="img-fluid"
              style={{ maxWidth: "200px" }}
            />
          </div>

          <h2
            className="text-center mb-4 createaccount-form-mainheader"
            style={{ color: "green" }}
          >
            Create Account
          </h2>

          <form className="createaccountform">
            <div className="row mb-3">
              <div className="col">
                <input
                  type="text"
                  name="firstname"
                  className="form-control"
                  onChange={formdata}
                  placeholder="First Name"
                />
                {errors.firstname && (
                  <small className="text-danger">{errors.firstname}</small>
                )}
              </div>
              <div className="col">
                <input
                  type="text"
                  name="lastname"
                  className="form-control"
                  onChange={formdata}
                  placeholder="Last Name"
                />
                {errors.lastname && (
                  <small className="text-danger">{errors.lastname}</small>
                )}
              </div>
            </div>

            <div className="mb-3">
              <input
                type="email"
                name="email"
                className="form-control"
                onChange={formdata}
                placeholder="Enter Email"
              />
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>

            <div className="row mb-3">
              <div className="col position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  onChange={formdata}
                  placeholder="Password"
                  autoComplete="new-password"
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  onClick={togglePasswordVisibility}
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ cursor: "pointer" }}
                />
                {errors.password && (
                  <small className="text-danger">{errors.password}</small>
                )}
              </div>
              <div className="col position-relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="passwordconformed"
                  className="form-control"
                  onChange={formdata}
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEyeSlash : faEye}
                  onClick={toggleConfirmPasswordVisibility}
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ cursor: "pointer" }}
                />
                {errors.passwordconformed && (
                  <small className="text-danger">
                    {errors.passwordconformed}
                  </small>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <input
                  type="text"
                  name="phonenumber"
                  className="form-control"
                  onChange={formdata}
                  placeholder="Phone Number"
                />
                {errors.phonenumber && (
                  <small className="text-danger">{errors.phonenumber}</small>
                )}
              </div>
              <div className="col">
                <input
                  type="text"
                  name="alternativePhone"
                  className="form-control"
                  onChange={formdata}
                  placeholder="Alternative Number"
                />
                {errors.alternativePhone && (
                  <small className="text-danger">
                    {errors.alternativePhone}
                  </small>
                )}
              </div>
            </div>
            <br />
            <button
              type="button"
              onClick={register}
              className="row btn btn-primary mb-3 w-100"
            >
              Create Account
            </button>
          </form>
          <br />
          <p
            className="createaccount-form-terms_and_service"
            style={{ color: "white", textAlign: "center" }}
          >
            By creating an account you agree to{" "}
            <b>LETS ENJOY Terms of Services</b> and <b>Privacy Policy</b>.
          </p>
          <p className="text-white text-center">
            Have an account?
            <NavLink
              to="/loginpage"
              className="createaccount-form-login-button"
              style={{ marginLeft: "5px", color: "orange" }}
            >
              Login
            </NavLink>
          </p>
        </div>
      </div>

      {/* ✅ Custom Styled Success Modal */}
      {showSuccessModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div
            className="modal-dialog"
            style={{
              marginTop: "40px",
            }}
          >
            <div
              className="modal-content text-center p-4"
              style={{ borderRadius: "12px" }}
            >
              <FontAwesomeIcon
                icon={faCheckCircle}
                style={{ fontSize: "50px", color: "green" }}
              />
              <h4 className="mt-3 fw-bold">Success</h4>
              <p className="mt-2">Account created successfully.</p>
              <button
                className="btn btn-success w-100 mt-3"
                style={{
                  borderRadius: "8px",
                  fontWeight: "bold",
                  padding: "10px",
                }}
                onClick={handleModalClose}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateAccountForm;
